import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/c01416e64dc18fdf8a1396f4374d4d9c/011a41a572be26a3d3db871d15682773.jpeg"
              alt="U.B.K Window Tint Services"
              className="h-12 md:h-16 w-auto mb-2 md:mb-4"
            />
            <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
              Professional window tinting services in Baltimore, MD. Quality installation with premium materials and lifetime warranty.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm md:text-lg font-bold mb-2 md:mb-4">Services</h3>
            <ul className="space-y-1 md:space-y-3">
              <li>
                <Link to="/window-tinting" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Window Tinting
                </Link>
              </li>
              <li>
                <Link to="/mobile-tinting" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Mobile Tinting
                </Link>
              </li>
              <li>
                <Link to="/precut-kits" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Pre-Cut Kits
                </Link>
              </li>
              <li>
                <Link to="/vehicle-decals" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Vehicle Decals
                </Link>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h3 className="text-sm md:text-lg font-bold mb-2 md:mb-4">Locations</h3>
            <ul className="space-y-1 md:space-y-3">
              <li>
                <Link to="/locations/baltimore" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Baltimore
                </Link>
              </li>
              <li>
                <Link to="/locations/owings-mills" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Owings Mills
                </Link>
              </li>
              <li>
                <Link to="/locations/columbia" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Columbia
                </Link>
              </li>
              <li>
                <Link to="/locations/ellicott-city" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Ellicott City
                </Link>
              </li>
              <li>
                <Link to="/locations/glen-burnie" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Glen Burnie
                </Link>
              </li>
              <li>
                <Link to="/locations/towson" className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap text-xs md:text-sm">
                  Towson
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm md:text-lg font-bold mb-2 md:mb-4">Contact</h3>
            <ul className="space-y-1 md:space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-accent mt-0.5 md:mt-1 mr-2 md:mr-3 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-sm md:text-base"></i>
                <div className="text-gray-400 text-xs md:text-sm">
                  <div>313 Nottingham Road</div>
                  <div>Baltimore, MD 21229</div>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-accent mt-0.5 md:mt-1 mr-2 md:mr-3 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-sm md:text-base"></i>
                <button 
                  onClick={() => window.location.href = 'tel:4438000348'}
                  className="text-gray-400 hover:text-accent transition-colors whitespace-nowrap cursor-pointer text-xs md:text-sm"
                >
                  (443) 800-0348
                </button>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-accent mt-0.5 md:mt-1 mr-2 md:mr-3 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-sm md:text-base"></i>
                <a href="mailto:ubkwindowtintservices@gmail.com" className="text-gray-400 hover:text-accent transition-colors break-all text-xs md:text-sm">
                  ubkwindowtintservices@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-sm md:text-lg font-bold mb-2 md:mb-4">Hours</h3>
            <ul className="space-y-1 md:space-y-2 text-xs md:text-sm">
              <li className="flex items-center text-gray-400">
                <span>Mon - Sat:&nbsp;</span>
                <span className="font-medium text-white">8am - 5pm</span>
              </li>
              <li className="flex items-center text-gray-400">
                <span>Sunday:&nbsp;</span>
                <span className="font-medium text-white">8am - 12pm</span>
              </li>
            </ul>
            <p className="mt-2 md:mt-4 text-accent font-semibold text-xs md:text-sm">BY APPOINTMENT ONLY</p>
            
            {/* Social Links */}
            <div className="flex space-x-3 md:space-x-4 mt-3 md:mt-6">
              <a
                href="https://www.facebook.com/1057846437740726"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 md:w-10 md:h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base md:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/u.b.k_window_tint_services?igshid=YmMyMTA2M2Y="
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 md:w-10 md:h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-base md:text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-6 md:mt-12 pt-4 md:pt-8 text-center">
          <p className="text-gray-400 text-xs md:text-sm">
            Copyright © 2025 U.B.K Window Tint Services - All Rights Reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
